// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__20ccN","options":"AnswerScale_options__3NcIx","selected":"AnswerScale_selected__2Cev7"};